import React from 'react';
import './index.css';
import Pages from './routes/pages';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';

//ReactDOM.render(<Pages />, document.getElementById('root'));


const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<Pages />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
